<template>
  <div class="LegalDocumentsComponent">
    <MuiCheckbox
      v-for="document in documents"
      :key="document.uuid"
      :name="document.name"
      :label="getOperatorDocuments()"
      required
      class="pt-3"
      label-position="right"
      size="xs"
    />
  </div>
</template>
<script>
import { MuiCheckbox } from '@ubeeqo/motion-ui';

export default {
  name: 'LegalDocumentsComponent',
  components: {
    MuiCheckbox,
  },
  props: {
    name: {
      required: true,
      type: String,
    },
    documents: {
      required: true,
      type: [Object, Array],
    },
    generalLang: {
      required: true,
      type: String,
    },
    operatorLang: {
      required: true,
      type: String,
    },
  },
  methods: {
    getOperatorDocuments() {
      const documents = this.documents.cs_operator.document;
      let text = '';
      documents.forEach((document, key) => {
        const separator = key === (documents.length - 1) ? 'and' : ',';
        text = `${text} ${separator} <a target="_blank" href="${document.url}">${document.document_name}</a>`;
      });
      return this.$t(this.operatorLang, { documents: text });
    },
  },
};
</script>
